export default __webpack_public_path__ + "f7ffa33a05904b9926911457e7a06cfa.png";